import React from 'react';
import './TjltzngcCenter.css';
import { Carousel, Form } from 'antd';
import { GetExhibitionBanner } from "../../api/api";
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../../store/actions"
import VlecImg from "../../component/VlecImg"



let img2 = require("../../static/images/photo-01.png");

class InnovationCenter extends React.Component {
    state = {
        GetExhibitionBanner: [],
    }

    componentWillMount() {

    }
    componentDidMount() {
        /*展厅接口*/
        // GetExhibitionBanner('TJ').then((response) => {
        //     let data = response.DataResult;
        //     this.setState({
        //         GetExhibitionBanner: data
        //     });
        // });
    }

    render() {
        const centertitle1 = this.props.local === 'en' ?
            "Lenovo (Tianjin) Carbon Neutrality Plant" : "联想天津零碳智能工厂";
        const centertitle3_1 = this.props.local === 'en' ?
            <span>Lenovo Tianjin Smart Campus, the pioneering "zero-carbon factory" in China's ICT industry, features two main sections: a 49,000 square meter production area and a 34,000 square meter research and development experimental area. It serves as the key production and research hub for Lenovo Group in the northern and northeastern Asia region, with a projected annual output of 3 million units and an annual output value exceeding 10 billion RMB upon full production.Equipped with cutting-edge technologies like intelligent IoT, digital twins, and AI applications, the campus boasts a state-of-the-art assembly line that can manufacture a desktop computer every 24 seconds and achieve a monthly output of up to 60,000 units. With an 85% automation rate in the testing section, it ensures complete transparency and the control of testing data. Additionally, the production line maintains a 60% automation rate during the final packaging stage, incorporating automated quality inspection and enabling the seamless traceability of all product information. Emphasizing a green, zero-carbon, and intelligent manufacturing approach, the campus integrates renewable energy sources, advanced digital platforms, and a comprehensive carbon-neutral framework, thus fostering a transformative shift towards eco-conscious and efficient manufacturing practices.</span>
            : 
            <span>作为中国信息和通信技术行业首家“零碳工厂”，联想（天津）智慧创新服务产业园最新的装配产线借助智能物联网、数字孪生、AI应用等先进技术，展示了信息和通信技术行业智能制造的最高水准。为与产线无缝对接，园区其他区域也全部采用智能化、自动化解决方案，为业界描绘出一幅高度信息化、自动化的智造新图景。园区不仅定位为“绿色零碳、数智引领、灯塔工厂”，而且以全流程碳排放跟踪、可再生能源使用、低能耗基础设施、数字化信息平台协同、碳中和绩效管理为零碳框架，致力于真正实现零碳工厂的目标。智慧园区还利用太阳能等清洁能源，设置离网型光伏产品，雨水调蓄系统节约用水，并在生产环节持续优化绿色供应链管理体系，推动整个产业链的绿色转型升级，助力天津制造业由“绿色制造”向“零碳智造”的高质量发展转型。</span>;
        const centertitle3_2 = this.props.local === 'en' ?
            <span style={{ fontWeight: "bold" }}>Features</span>
            : 
            <span style={{ fontWeight: "bold" }}>园区定位</span>;
        const centertitle3_3 = this.props.local === 'en' ?
            <span>Green zero-carbon digitalized lighthouse factory</span>
            : 
            <span>绿色零碳，数智引领，灯塔工厂</span>;
        const centertitle3_4 = this.props.local === 'en' ?
            <span>Smart manufacturing exhibition center</span>
            : 
            <span>具备制造功能的联想智能制造展示中心</span>;
        const centertitle3_5 = this.props.local === 'en' ?
            <span>Representing the highest level of smart manufacturing</span>
            : 
            <span>展示的内容代表联想智能制造最高水平</span>;
        const centertitle3_6 = this.props.local === 'en' ?
            <span>Replicable zero-carbon smart manufacturing solutions</span>
            : 
            <span>打造出科学可复制的零碳智造解决方案</span>;
       

        const makedes = this.props.local === 'en' ?
            <span>Based on Lenovo’s practices in smart manufacturing, this area demonstrates Lenovo’s innovation in the whole value chain of manufacturing including <span className="quot">&quot;</span>Research, Supply Chain, Production, Sales and Service<span className="quot">&quot;</span>. Cases of Lenovo's global supply chain management, digital product development and production, and industrial metaverse solutions are presented.</span>
            : 
            <span>智能制造展区围绕联想在智能制造领域的实践，全面地展现了联想研产供销服（研发、供应链、营销、销售、服务）全价值链环节的模式创新。联想独特的全球供应链、数字化研发生产和工业元宇宙平台的各个案例都展现于此。</span>;
        const f1Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,1<sup>st</sup>floor<br />— 3,000 m<sup>2</sup></h4> : <h4>联想未来中心1层<br />——3000 m<sup>2</sup></h4>;
        const f2Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,2<sup>nd</sup>floor<br />— 2,000 m<sup>2</sup></h4> : <h4>联想未来中心2层<br />——2000 m<sup>2</sup></h4>;
        const f3Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,3<sup>rd</sup>floor<br />— 1,000 m<sup>2</sup></h4> : <h4>联想未来中心3层<br />——1000 m<sup>2</sup></h4>;
        return (<div>
            {/*轮播图片*/}
            <div>
                <Carousel autoplay>
                    <img src="images/tj/GC_Banner.jpg" alt="" />
                </Carousel>
            </div>
            <div className="indexDiv Innovation_Con">
                <div className="center">
                    <div className="titleH4">
                        <h4>
                            {centertitle1}
                        </h4>
                        <p className="shsmartP">
                            {centertitle3_1}
                            <br /><span></span><br/>
                            {centertitle3_2}
                            <br /><span></span><br/>
                            {centertitle3_3}
                            <br /><span></span><br/>
                            {centertitle3_4}
                            <br /><span></span><br/>
                            {centertitle3_5}
                            <br /><span></span><br/>
                            {centertitle3_6}
                        </p>

                    </div>
                </div>
                {/*下面的图片*/}
                {/* <div className="center centerDiv">
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce01.png" alt="" />
                            </dt>
                            <dd>
                                {f1Title}
                                <p><FormattedMessage id="intl-center-f1Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f1Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce02.png" alt="" />
                            </dt>
                            <dd>
                                {f2Title}
                                <p><FormattedMessage id="intl-center-f2Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f2Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce03.png" alt="" />
                            </dt>
                            <dd>
                                {f3Title}
                                <p><FormattedMessage id="intl-center-f3Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f3Des" /></p>
                    </div>
                </div> */}
                <div className="imgDiv">
                    <ul className="shimgBock">
                        <li>
                            <img src="images/tj/gc_sec1.png" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjltzngccenter-sec1title" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec1des1" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/tj/gc_sec2.png" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-tjltzngccenter-sec2title" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des1" />    
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des2" />    
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des3" />    
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des4" />    
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des5" />    
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec2des6" />    
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/tj/gc_sec3.png" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-tjltzngccenter-sec3title" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec3des1" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img style={{height:'507px'}} src="images/tj/gc_sec4.png" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-tjltzngccenter-sec4title" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec4des1" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/tj/gc_sec5.png" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-tjltzngccenter-sec5title" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-tjltzngccenter-sec5des1" />
                                    </p>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    }
};
export default connect(state => ({ ...state.Language }), actions.Language)(InnovationCenter)


// WEBPACK FOOTER //
// ./src/containers/TjltzngcCenter/TjltzngcCenter.js